import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/7/thumb-landscape.jpg"

const Post7 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Miu Miu／マドラス／20 x12 x9cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          王道のガーリーテイストでありながら、可愛いだけにはおさまらない個性あふれるデザインが印象的な「ミュウミュウ(Miu Miu)」のバッグ。実はこのブランド、プラダのセカンドラインであることはご存知でしたか？プラダの上品さと高級感を取り入れつつ、さらにフェミニンで可愛らしい要素をプラスした世界観がブランドの大きな魅力となっており、若い世代の女性を中心に根強い人気があります。今回はそんなミュウミュウの人気バッグ10選をご紹介します♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>マテラッセ２WAYバッグ</h2>
          <p>「マテラッセ」とは、表面にギャザー加工が施された生地のことで、ミュウミュウを特徴づける代表的なモチーフになっています。上品で飽きの来ないデザインと、程よいサイズ感が使い勝手抜群のアイテムです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/2.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Miu Miu／マテラッセ／28 x20 x13cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/3.jpg" alt="" />
            <span className="text-center">Miu Miu／マテラッセ／26 x18 x16cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/4.jpg" alt="" />
            <span className="text-center">Miu Miu／マテラッセチェーンショルダーバッグ／20 x14 x2cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>マドラス</h2>
          <p>自然で美しいシボ（シワ模様）加工が施された「マドラス」レザーを使った上質感溢れるバッグ。クラシックな佇まいは持っているだけでワンランク上の女性を演出してくれること間違いなしです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/6.jpg" alt="" />
          </figure>
        </div>      
        <span className="text-center">Miu Miu／マドラス／27 x20 x10cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/7.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラスビコローレ／34 x24 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/8.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラス／28 x18 x13cm</span> 
          </figure>
        </div>   
        <div className="text-max-width">
          <h2>クリスタルレザーバッグ</h2>
          <p>「クリスタルレザーバッグ」は、美しく光るクリスタルのストラップがコーデをドレッシーに演出してくれるアイテム。結婚式などのパーティーシーンにぴったりな華のあるデザインが大人女性に大人気♪</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Miu Miu／ナッパクリスタル／32 x20 x7cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/11.jpg" alt="" />
            <span className="text-center">Miu Miu／ナッパクリスタル／29 x13 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/12.jpg" alt="" />
            <span className="text-center">Miu Miu／クリスタルビジュー／27 x14 x3cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/miumiu" className="view-all-button">
          ミュウミュウのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>レザークラッチ</h2>
          <p>シンプルなクラッチバッグを持つとコーデが寂しい印象になりがち・・・という方には、ミュウミュウの「レザークラッチ」がオススメです。シンプルなフォルムにマテラッセの華やかさが映え、大人の上品さを底上げしてくれるアイテムです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/14.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Miu Miu／クラッチバッグ／27 x18 x2cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/15.jpg" alt="" />
            <span className="text-center">Miu Miu／クラッチバッグ／21 x13 x1cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/16.jpg" alt="" />
            <span className="text-center">Miu Miu／クラッチバッグ／27 x17 x1cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>マドラスショルダーバッグ</h2>
          <p>「マドラスショルダーバッグ」は、小さめのサイズ感がアクセサリー感覚で楽しめるアイテム。フェミニンなコーデにはもちろん、落ち着いたトーンのシンプルなコーデにアクセントとして取り入れるのもオススメ。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Miu Miu／マドラスショルダーバッグ／19 x11 x3cm</span>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/19.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラスショルダーバッグ／23 x14 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/20.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラスショルダーバッグ／22 x15 x5cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ミュウロゴショルダーバッグ</h2>
          <p>フェミニンな印象のバッグが多いミュウミュウの中で目を引くのが「ミュウロゴショルダーバッグ」。かっちりとしたフォルムに中央のロゴパーツが引き立つシンプルなデザインは、いつものコーデをカッコ良く決めてくれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/7/21.jpg" alt="" />
        </figure> 
        <span className="text-center">Miu Miu／ミュウロゴ／21 x13 x8cm</span>                   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/22.jpg" alt="" />
            <span className="text-center">Miu Miu／ミュウロゴ／21 x13 x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/23.jpg" alt="" />
            <span className="text-center">Miu Miu／ミュウロゴ／20 x13 x5cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>マドラスボストンバッグ</h2>
          <p>服装や年代を問わないシンプルなデザインと豊富なカラーバリエーションが人気の「マドラスボストンバッグ」。マチ幅が広く、荷物が多めに入るのでデイリーに活躍してくれること間違いなしです♪</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/24.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/25.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Miu Miu／マドラス／28 x20 x15cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/26.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラス／27 x20 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/27.jpg" alt="" />
            <span className="text-center">Miu Miu／マドラス／26 x18 x15cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/miumiu" className="view-all-button">
          ミュウミュウのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>マテラッセショルダーバッグ</h2>
          <p>コロンとした小さなサイズ感が可愛らしい「マテラッセショルダーバッグ」。カジュアルコーデのワンポイントとして合わせれば、上品でこなれた印象を演出してくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/28.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/29.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">Miu Miu／2WAYバッグ／15 x12 x7cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/30.jpg" alt="" />
            <span className="text-center">Miu Miu／ショルダーバッグ／17 x9 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/31.jpg" alt="" />
            <span className="text-center">Miu Miu／ショルダーバッグ／20 x12 x6cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トートバッグ</h2>
          <p>「トートバッグ」は、A4サイズも楽々収納できるサイズ感とジッパーポケットが付いた機能的なデザインがお仕事バッグにぴったり！シンプルなデザインなので、オフィスコーデに合わせやすいのも嬉しいですね♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/32.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/33.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Miu Miu／トートバッグ／32 x32 x14cm</span>             
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/34.jpg" alt="" />
            <span className="text-center">Miu Miu／トートバッグ／33 x34 x14cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/35.jpg" alt="" />
            <span className="text-center">Miu Miu／トートバッグ／32 x32 x10cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バケットバッグ</h2>
          <p>「バケットバッグ」は持つだけでトレンド感のある印象を作ってくれる優秀アイテム。普段のカジュアルコーデをスタイリッシュに格上げしてくれますよ♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/36.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/37.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Miu Miu／ショルダーバッグ／14 x21 x9cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/38.jpg" alt="" />
            <span className="text-center">Miu Miu／ショルダーバッグ／14 x18 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/7/39.jpg" alt="" />
            <span className="text-center">Miu Miu／2WAYバッグ／26 x27 x11cm</span> 
          </figure>
        </div>
        <div className="text-two-cloumn">
          <h2>乙女心をくすぐる<br className="pc"></br>ミュウミュウのバッグ</h2>
          <p>上品で可愛らしく、乙女心をくすぐるミュウミュウのバッグは見ているだけでワクワクしてきますね♪ラクサスでも多数のバッグを取り扱っていますので、ぜひオシャレの参考に覗いてみてくださいね♡</p>
        </div>                                        
        <Link to="https://laxus.co/app/pc/bags/miumiu" className="view-all-button">
          ミュウミュウのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post7

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 7}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
